import { c as _c } from "react/compiler-runtime";
import { PaymentMethods } from 'api-graphql-types/enums';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import styles from './FiscalYearChangeNotice.module.css';
function FiscalYearChangeNotice(t0) {
  const $ = _c(9);
  const {
    paymentMethod
  } = t0;
  const t = useTranslations("nextjs.donate");
  const [isNearFiscalYearChange, setIsNearFiscalYearChange] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Date().getFullYear();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [year, setYear] = useState(t1);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (typeof window === "undefined") {
        return;
      }
      const urlParams = new URLSearchParams(window.location.search);
      const timeout = setTimeout(() => {
        const now = urlParams.has("fake-date") ? new Date(urlParams.get("fake-date") ?? "") : new Date();
        setIsNearFiscalYearChange(now.getMonth() === 11 && now.getDate() > 26);
        setYear(now.getFullYear());
      }, 0);
      return () => clearTimeout(timeout);
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  const needsFiscalYearChangeNotice = isNearFiscalYearChange && ([PaymentMethods.DirectDeposit, PaymentMethods.StripeSepaDebit] as Array<PaymentMethods>).includes(paymentMethod);
  if (!needsFiscalYearChangeNotice) {
    return null;
  }
  const t4 = year + 1;
  let t5;
  if ($[3] !== t || $[4] !== t4 || $[5] !== year) {
    t5 = t("fiscal_year_change_notice", {
      old_year: year,
      new_year: t4
    });
    $[3] = t;
    $[4] = t4;
    $[5] = year;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <div className={styles.fiscalYearChangeNotice}>{t5}</div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}
export default FiscalYearChangeNotice;